/* Makes every footer on the site carry the same link columns, and the same
   company line. v6.

   v1 made the hand-built templates carry the two columns the shared page-foot
   snippet already had: "What it does" and "Rockkt". It skipped any footer that
   already had them.

   v2 added a "Features" column with the six pages that used to be homepage
   sections, everywhere, including the footers the snippet renders, and restyled
   the grid to four tracks.

   v3 is v2 with two more features in that column: Rockkt One and Playbooks,
   eight in total.

   v4 adds Integrations, nine in total, matching the header menu
   (rockkt-nav-features-v3.js). The band at the foot of the homepage
   (rockkt-router-v7.js) also carries nine but NOT the same nine: it has ROI
   where these two have Integrations, because the band stands in for sections
   that were moved off the homepage and Integrations never was one. The header
   menu's file explains the split in full.

   v5 drops "Delivered with care, from the UK." from the bottom bar.

   v6 drops "Registered in England & Wales." from the copyright line, leaving
   "© 2026 Rockkt." on its own. See name() for the one thing to check before
   anyone decides that was a good idea.

   THE COUNT CHANGE IS SAFE TO SHIP. sync() below replaces any Features column
   whose link count does not match this list, so a footer left over from v3 is
   rebuilt with nine rather than kept at eight. That test was added in v3 for
   exactly this, and it is the reason a list can grow here without a cache
   problem.

   Playbooks points at /pages/send-playbooks, not /pages/playbooks: that handle
   belongs to the guides hub, which is content rather than product. The guides
   hub is reachable from Mission Control and the other content pages; it is
   deliberately not in this column, which is features only. */
(function () {
  var FEATURE_PAGES = [
    ['/pages/rockkt-one',     'Rockkt One'],
    ['/pages/send-playbooks', 'Playbooks'],
    ['/pages/gift-lab',       'Gift Lab'],
    ['/pages/design-studio',  'Design Studio'],
    ['/pages/flight-deck',    'Flight Deck'],
    ['/pages/tracking',       'Tracking'],
    ['/pages/navigator',      'Navigator'],
    ['/pages/compliance',     'Compliance'],
    ['/pages/integrations',   'Integrations']
  ];
  var WHAT_IT_DOES = [
    ['/pages/find-the-address', 'Find the address'],
    ['/pages/write-the-letter', 'Write the letter'],
    ['/pages/design-the-envelope', 'Design the envelope'],
    ['/pages/landing-pages', 'Land the page'],
    ['https://rockkt.com/blogs/how-rockkt-helps', 'Mission Control']
  ];
  var ROCKKT = [
    ['/pages/compare', 'Straight Comparison'],
    ['/pages/pricing', 'Pricing'],
    ['/pages/faq', 'Questions & Answers'],
    ['/pages/the-boring-stuff', 'The Boring Stuff'],
    ['/pages/request-an-invite', 'Join Rockkt']
  ];

  function column(heading, links, cls) {
    var col = document.createElement('div');
    col.className = 'foot-col foot-links ' + cls;
    var h = document.createElement('h4');
    h.textContent = heading;
    col.appendChild(h);
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[0];
      a.textContent = l[1];
      col.appendChild(a);
    });
    return col;
  }

  function layout(grid) {
    var cols = grid.querySelectorAll('.foot-col').length;
    var w = window.innerWidth;
    if (w <= 620)      grid.style.gridTemplateColumns = '1fr';
    else if (w <= 960) grid.style.gridTemplateColumns = '1fr 1fr';
    else               grid.style.gridTemplateColumns = '1.4fr' + ' 1fr'.repeat(cols);
  }

  function sync() {
    var grid = document.querySelector('footer .foot-grid');
    if (!grid) return;

    /* The two v1 columns, for footers that still only carry "Explore". */
    if (!grid.querySelector('.rk-synced') && grid.textContent.indexOf('Find the address') === -1) {
      grid.querySelectorAll('.foot-col.foot-links').forEach(function (old) { old.remove(); });
      grid.appendChild(column('What it does', WHAT_IT_DOES, 'rk-synced'));
      grid.appendChild(column('Rockkt', ROCKKT, 'rk-synced'));
    }

    /* The Features column, for every footer. First link column, after the brand.
       A column built by an earlier version is short by one or more links; it is
       replaced rather than left as it is. */
    var existing = grid.querySelector('.rk-features');
    if (existing && existing.querySelectorAll('a').length !== FEATURE_PAGES.length) {
      existing.parentNode.removeChild(existing);
      existing = null;
    }
    if (!existing) {
      var first = grid.querySelector('.foot-col');
      var col = column('Features', FEATURE_PAGES, 'rk-features');
      if (first) grid.insertBefore(col, first); else grid.appendChild(col);
    }

    layout(grid);
  }

  /* The copyright line. Two corrections, both idempotent, both applied here
     because index.liquid and the hand-built templates each hold their own copy
     inside files the Admin API will not replace as text. Both footer snippets
     were also fixed at source, so on most pages there is nothing to do.

       "Rockkt Ltd." -> "Rockkt."                        (from v4)
       "Registered in England & Wales." -> gone           (new in v6)

     ── BEFORE ANYONE PUTS THE SECOND ONE BACK, OR TAKES IT FURTHER ─────────
     That sentence was the ONLY place on the whole site that said where the
     company is registered - checked across the footer and /pages/the-boring-
     stuff on 23 Sept 2026, and the only hit anywhere was this line. A UK
     limited company's website is normally expected to state its registered
     name, its company number and its place of registration somewhere a visitor
     can find. Glen asked for it off the footer, which is a layout decision and
     fine; where those particulars now live is a separate question and it is
     open. If they go back anywhere, The Boring Stuff is the page for them.
     This is a note to check, not legal advice. */
  function name() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      var t = spans[i].textContent;
      if (t.indexOf('Rockkt Ltd.') > -1) t = t.replace('Rockkt Ltd.', 'Rockkt.');
      t = t.replace(/\s*Registered in England\s*&\s*Wales\.?/i, '');
      if (t !== spans[i].textContent) spans[i].textContent = t;
    }
  }

  /* "Delivered with care, from the UK." — removed everywhere.

     WHY A SCRIPT AND NOT JUST A DELETE. The line is written out four ways: in
     snippets/rockkt-home-foot-v1.liquid and snippets/rockkt-page-foot.liquid,
     which were edited at source and no longer carry it; and inside
     templates/index.liquid and the other hand-built templates, which are past
     what the Admin API will replace as text. This is the only lever that
     reaches those. Same route, and the same reason, as name() above.

     It matches on the span's own text rather than an index, so it cannot take
     the copyright line with it if the order ever changes, and it leaves the
     currency picker that sits in the same bar alone. Idempotent: a footer that
     has already been edited at source has nothing here to find.

     When index.liquid is next rebuilt, delete the span there and this can go. */
  function tagline() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      if (/Delivered with care/i.test(spans[i].textContent || '')) {
        spans[i].parentNode.removeChild(spans[i]);
      }
    }
  }

  function run() { sync(); name(); tagline(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  var rt = null;
  window.addEventListener('resize', function () {
    if (rt) clearTimeout(rt);
    rt = setTimeout(function () { var g = document.querySelector('footer .foot-grid'); if (g) layout(g); }, 120);
  });
})();
